const Index = resolve => require.ensure([], () => resolve(require('./Index.vue')), 'meeting_booking_index');

export default [{
  path: '/meeting/booking',
  name: 'meeting_booking_index',
  component: Index,
  meta: {
    title: '会议室预约',
    layout: 'compete',
  },
}, {
  path: '/meeting/reserve',
  name: 'meeting_reserve_index',
  component: Index,
  meta: {
    title: '会议室预约',
    layout: 'compete',
  },
}];




// WEBPACK FOOTER //
// ./src/pages/user/meeting/booking/index.js